import { convertTimeString } from "./TimeConversion";

export function downloadTextoTxt(soapNote, noteName, createdAt) {
    const blob = new Blob([`Visit at: ${convertTimeString(createdAt)} \n\n`, soapNote], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${noteName}.txt`;
    link.click();
    URL.revokeObjectURL(url);
}